import actionTypes from './actionTypes';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import { setAlert } from 'src/typescript/components/alert/actions';
import { closeModal, setModalProps }  from 'src/modules/shared/modal/actions';
import * as log from 'loglevel';
import i18n from 'src/utils/translate';
import { pluralize } from 'src/utils/string';

export const followCommunity = (community, userId, successMessage, silent = false) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FOLLOW_COMMUNITY });
    try {
      const response = await api.auroraPost('user-group-subscriptions', {
        userId,
        groupId: community.communityId,
      });
      const { data: { status } } = response;

      if (!!status && !status.success) {
        if (!silent) {
          dispatch(setAlert(status.message));
        }
        return dispatch({ type: actionTypes.FOLLOW_COMMUNITY_FAILURE, error: status });
      }

      if (!silent && successMessage) {
        dispatch(setAlert(successMessage, 'success'));
      }
      return dispatch({
        type: actionTypes.FOLLOW_COMMUNITY_SUCCESS,
        community,
      });
    } catch (ex) {
      log.error(ex);
      dispatch(setAlert(ex.message));
      return dispatch({ type: actionTypes.FOLLOW_COMMUNITY_FAILURE, error: ex });
    }
  };
};

export const unfollowCommunity = (community, userId, successMessage, noClose = false) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY });
    try {
      const response = await api.auroraDel('user-group-subscriptions', {
        params: {
          userId,
          groupId: community.communityId,
        },
      });
      const { data: { status } } = response;

      if (!!status && !status.success) {
        dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY_FAILURE, error: status });
        dispatch(setAlert(status.message));
        return;
      }

      dispatch({
        type: actionTypes.UNFOLLOW_COMMUNITY_SUCCESS,
        communityId: community.communityId,
        slug: community.slug,
      });
      if (noClose) return;
      dispatch(closeModal());
      dispatch(setAlert(successMessage, 'success'));
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const sendInvites = (communitySlug, emails) => async (dispatch, getState) => {
  try {
    const api = createAuthenticatedApiInstance(getState);
    const { data: { invitesSent: successful, failedValidation: invalid } } = await api.post(`private/communities/${communitySlug}/invites`, { emails });

    if (successful.length > 0) {
      dispatch(setAlert(pluralize(i18n.t('%1$s invite sent!'), i18n.t('%1$s invites sent!'), successful.length), 'success'));
    }
    if (successful.length === emails.length) {
      dispatch(closeModal());
    } else {
      dispatch(setModalProps({successful, invalid}));
    }
  } catch (ex) {
    log.error(ex);
    dispatch(setAlert(ex.message));
  }
};
